import * as Yup from 'yup';

export const passwordRegex = () => {
	return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
};

export const LoginValidationSchema = Yup.object().shape({
	// email: Yup.string().email('Invalid Email').required('Please enter email.'),
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		),
	password: Yup.string()
		.required('Please enter password.')
		.matches(
			passwordRegex(),
			'Password must be 8 characters long. (At least one number, one uppercase character, one lowercase character, and one special character)'
		)
});

export const ResetPasswordSchema = Yup.object().shape({
	password: Yup.string()
		.required('Please enter password.')
		.matches(
			passwordRegex(),
			'Password must be 8 characters long. (At least one number, one uppercase character, one lowercase character, and one special character)'
		),
	confirmNewPassword: Yup.string()
		.required('Please enter confirm password')
		.oneOf([Yup.ref('password')], 'Confirm Password does not match with  password')
});

export const forgetPasswordSchema = Yup.object().shape({
	// email: Yup.string().email('Invalid Email').required('Please enter email.')
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		)
});

const mobileRegx = /^[0-9]{10}$/;

export const EditProfileValidationSchema = Yup.object().shape({
	username: Yup.string()
		.required('Please enter user name.')
		.max(255, 'Maximum 255 character is allowed'),
	// email: Yup.string().email('Invalid Email').required('Please enter email id.'),
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		),
	mobileNumber: Yup.string()
		.matches(mobileRegx, 'Please enter valid mobile Number')
		.required('Please enter mobile number. '),
	address: Yup.string()
		.required('Please enter address.')
		.max(255, 'Maximum 255 character is allowed'),
	profileImage: Yup.mixed().optional()
});

export const GeofenceSchema = Yup.object().shape({
	engName: Yup.string().required('English name is required'),
	arbName: Yup.string().required('Arabic name is required')
});

export const addHolidaySchema = Yup.object().shape({
	date: Yup.string().required('Date is required'),
	engDescription: Yup.string()
		.required('English name is required')
		.max(255, 'Maximum 255 character is allowed'),
	arbDescription: Yup.string()
		.required('Arabic name is required')
		.max(255, 'Maximum 255 character is allowed')
});

export const rolesAndPermissionSchema = Yup.object().shape({
	roleName: Yup.string()
		.required('Role name is required')
		.max(255, 'Maximum 255 character is allowed')
});

export const contactUsSchema = Yup.object().shape({
	answer: Yup.string().required('Answer is required')
});

export const ProductSchema = Yup.object().shape({
	category: Yup.number()
		.required('Product category is required')
		.oneOf([1, 2], 'Invalid product category'),
	logoName: Yup.string()
		.required('Brand name is required')
		.max(100, 'Logo name must be at most 100 characters'),
	logoUrl: Yup.string().nullable().required('Logo is required'),
	//   logoUrl: Yup.string()
	//     .required('Logo image is required')
	//     .test('is-image', 'Please upload a valid image', (value) => {
	//       // Skip validation if editing and image already exists
	//       if (value && value.startsWith('http')) return true;
	//       return false;
	//     }),
	sizes: Yup.array()
		.of(
			Yup.object().shape({
				size: Yup.number()
					.required('Size is required')
					.positive('Size must be positive')
					.typeError('Size must be a number')
			})
		)
		.min(1, 'At least one size is required')
		.test('unique-sizes', 'Sizes must be unique', sizes => {
			if (!sizes) return true;
			const sizeValues = sizes.map(s => s.size);
			return new Set(sizeValues).size === sizeValues.length;
		})
	// size: Yup.number().min(1, 'size must be greater than 0').required('size is required'),
	// price: Yup.number()
	// 	.min(1, 'Product price must be greater than 0')
	// 	.required('Product price is required')
});

export const SettlementFormSchema = Yup.object().shape({
	// payAmount: Yup.number()
	// 	// .min(0, 'PayAmount must be at least 0')
	// 	.required('PayAmount is Required'),
	// recivedAmount: Yup.number()
	// 	.min(0, 'RecivedAmount must be at least 0')
	// 	.required('RecivedAmount is Required')
	// comment: Yup.string().required('Comment is required')
});

export const cmsAddSchema = Yup.object().shape({
	enTitle: Yup.string().required('Heading is required')
	// arTitle: Yup.string().required('Heading is required')
});

export const subAdminSchema = Yup.object().shape({
	// email: Yup.string().required('Email is required').email('Please enter valid email'),
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		),
	firstName: Yup.string()
		.matches(/^[aA-zZ\s]+$/, 'Please enter valid first name')
		.max(40)
		.required('First Name is required'),

	lastName: Yup.string()
		.matches(/^[aA-zZ\s]+$/, 'Please enter valid last name')
		.max(40)
		.required('Last Name is required'),

	mobileNumber: Yup.string()
		.matches(mobileRegx, 'Mobile number must be of 09 digit')
		.required('Contact number is required'),
	roleId: Yup.number().min(1, 'Role name is required').required('Role name is required')
});

export const notificaionSchema = Yup.object().shape({
	descriptionEng: Yup.string().required('English message is Required').min(5).max(240),
	titleEng: Yup.string().required('English Title is Required').max(160),
	// descriptionArb: Yup.string().required('arabic message is Required').min(5).max(240),
	// titleArb: Yup.string().required('Arabic Title is Required').max(160),
	notifyto: Yup.number().required('please select to notify'),
	notifyIds: Yup.array().optional()
});

// export const addVendorSchema = Yup.object().shape({
// 	name: Yup.string().required('First Name is required'),
// 	lastName: Yup.string().required('Last Name is required'),
// 	businessName: Yup.string().required('Shop Name is required'),
// 	location: Yup.string().required('Location is required'),
// 	// countryCode: Yup.string().required('Country Code is required'),
// 	mobileNumber: Yup.string()
// 		.matches(mobileRegx, 'Please enter valid mobile Number')
// 		.required('Mobile Number is required'),
// 	// email: Yup.string().email('Invalid email').required('Email is required'),
// 	email: Yup.string()
// 		.required('Please Enter Your Email')
// 		.matches(
// 			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
// 			'Please Enter Valid Email'
// 		),
// 	idNumber: Yup.string().required('ID Number is required'),
// 	businessProfileUrl: Yup.mixed().required('Business Profile Is Required'),
// 	// kraPinCertificateUrl: Yup.mixed().required('KraPinCertificate Is Required')
// 	// profileImage: Yup.mixed().optional()
// 	// status: Yup.boolean().required('status required')
// 	// businessProfileUrl: Yup.string().required('Business License URL is required'),
// });
export const addVendorSchema = Yup.object().shape({
	firstName: Yup.string().required('First Name is required'),
	lastName: Yup.string().required('Last Name is required'),
	businessName: Yup.string().required('Shop Name is required'),
	location: Yup.string().required('Location is required'),
	mobileNumber: Yup.string()
		.matches(mobileRegx, 'Please enter valid mobile Number')
		.required('Mobile Number is required'),
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		),
	idNumber: Yup.string()
		.required('ID Number is required')
		.matches(
			/^[0-9]{2}-[0-9]{6}[A-Z][0-9]{2}$/,
			'Invalid ID Number format (12-345678A90)'
		),
	businessProfileUrl: Yup.mixed().required('Business Profile Is Required'),
	accountHolderName: Yup.string().required('Account Holder Name is required'),
	bankName: Yup.string().required('Bank Name is required'),
	accountNumber: Yup.string().required('Account Number is required')
});

export const addDriverSchema = Yup.object().shape({
	firstName: Yup.string().required('Driver First Name is required'),
	lastName: Yup.string().required('Driver Last Name is required'),
	mobileNumber: Yup.string()
		.matches(mobileRegx, 'Please enter valid mobile Number')
		.required('Mobile Number is required'),
	licenseNumber: Yup.string().required('License Number is required'),
	vehicleType: Yup.string().required('Vehicle Type is required'),
	vehicleMake: Yup.string().required('Vehicle Make is required'),
	vehicleModel: Yup.string().required('Vehicle Model is required'),
	// email: Yup.string().email('Invalid email').required('Email is required'),
	email: Yup.string()
		.required('Please Enter Your Email')
		.matches(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			'Please Enter Valid Email'
		),
	address: Yup.string().required('Address is required'),
	documentUrl: Yup.mixed().required('Vehicle Document Is Required'),
	licenseUrl: Yup.mixed().required('Driving License Is Required'),
	driverVehiclePhoto: Yup.mixed().required('Driver Vehicle Photo Is Required'),
	nationalId: Yup.string().required('National Id is required'),
	vehicleRegistrationNumber: Yup.string().required(
		'Vehicle Registration Number is required'
	),
	accountHolderName: Yup.string().required('Account Holder Name is required'),
	bankName: Yup.string().required('Bank Name is required'),
	accountNumber: Yup.string().required('Account Number is required')
	// profileImage: Yup.mixed().optional(),
	// geofencesId: Yup.number()
	// 	.min(1, 'Geofences is required')
	// 	.required('Geofences is required')
	// drivingLicance: Yup.mixed()
	// 	.test('isSupportedFormat', 'Only JPEG and PNG formats are allowed', value => {
	// 		if (!value) return true; // Allow empty value if it's not required
	// 		const supportedFormats = ['image/jpeg', 'image/png'];
	// 		return supportedFormats.includes(value?.type);
	// 	})
	// 	.required('Image is required')
});

export const VendorPlanSchema = Yup.object().shape({
	planName: Yup.string().required('Plan name is required'),
	amount: Yup.number()
		.typeError('Amount must be a number')
		.positive('Amount must be positive')
		.required('Amount is required'),
	validity: Yup.number()
		.typeError('Validity must be a number')
		.positive('Validity must be positive')
		.required('Validity is required')
});

export const DriverPlanSchema = Yup.object().shape({
	amount: Yup.number()
		.typeError('Amount must be a number')
		.positive('Amount must be positive')
		.required('Amount is required')
});
